/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import withViewSize from 'HOC/withViewSize/withViewSize';
import SearchBar from 'Scenes/Headers/SearchBar/SearchBar';
import styles from './GlobalNav.module.css';

const MobileSearchBar = ({ showSearchBar, viewSize }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const headerElements = document.getElementsByClassName('header');
  const headerElement = headerElements && headerElements[0];

  // observe header class and update isMenuOpen state
  useEffect(() => {
    const observer = new MutationObserver((mutationRecords) => {
      const { classList = [] } = mutationRecords[0].target;
      if (classList.contains('is-navigation-menu-visible')) {
        setIsMenuOpen(true);
      } else {
        setIsMenuOpen(false);
      }
    });
    if (headerElement) {
      observer.observe(headerElement, {
        attributeFilter: ['class'],
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [headerElement]);

  return (
    <>
      {!isMenuOpen && (
        <div
          className={`${styles.searchBar} ${
            showSearchBar ? styles.open : styles.closed
          }`}
        >
          <SearchBar viewSize={viewSize} />
        </div>
      )}
    </>
  );
};

MobileSearchBar.propTypes = {
  showSearchBar: PropTypes.bool,
  viewSize: PropTypes.string.isRequired,
};

MobileSearchBar.defaultProps = {
  showSearchBar: false,
};

const mapStateToProps = (state) => ({
  showSearchBar: state.searchState.showSearchBar,
  viewSize: state.viewState.viewSize,
});

export default compose(
  withViewSize,
  connect(mapStateToProps, {})
)(MobileSearchBar);
